// 支持es6 javascript 库
// import 'babel-polyfill'
// require('es5-shim')

import Vue from 'vue'

import './common/flexible'
// 数据上报
import report from './report'
// const report = process.env.RUN_ENV === 'production' ? require('./report') : {};

// vuex 仓库
import store from './vuex/store'

// 微信SDK调用
import wechat from './wechat/index'

// import { registryToast } from './modules/components/toast'

// 初始化全局toast
import { ToastPlugin } from '@lx-frontend/cvux'
import './common/mixins'
import App from './App.vue'
// 初始化全局Message
import message from '../src/plugins/VuePlugin/QiyiMessage'
// 微信SDK调用
// import wxHelp from './common/wxhelp'

// api配置
import rest from './rest'
// 路由配置
import router from './router'
import './stylesheets/global.less'

import './common/fastclickHack' // 使用require导入样式文件

if (process.env.RUN_ENV !== 'production') {
  import('./mock/index')
  import('./debug')

  const VConsole = require('vconsole')
  const vConsole = new VConsole()
}
Vue.use(ToastPlugin) // this.$cvux.toast.show({}), this.$cvux.toast.hide({})
Vue.use(message)
// const FastClick = require('fastclick')
// FastClick.attach(document.body)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  rest,
  wechat, // wx
  report, // sentry 数据上报
  template: '<App/>',
  components: {
    App
  }
})
